// extracted by mini-css-extract-plugin
export default {"app":"Test_app__Eohbt","t1":"Test_t1__eYsLA","t2":"Test_t2__lyemW","t3":"Test_t3__iO1qj"};